import {Cari} from './cari';

export class CariListePage {

  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: Cari[];


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): Cari[] {
    return this.pResults;
  }

  public set results(list: Cari[]) {
    if (list != null) {
      this.pResults = list.map(t => new Cari(t));
    }
  }

}
